module.exports = __webpack_public_path__ + "static/media/no-data-collection.91dee48e.svg";